import { token as tokenService, localUserId } from "../../store";
import { setCookie } from "../../../utils/cookiesUtils";

/**
 * Checks the response data object coming from signup request to see if there is token and user related
 * data included.
 * @param {Object} response - Response from signup request.
 * @returns {Boolean}
 */
export function canUpdateToken(response) {
  return !!response.data && !!response.data.token && !!response.data.user;
}

/**
 * Updates both JWT token and local globalUserId stored in SDK context (and also in cache in case of JWT token).
 * @param token
 * @param globalUserId
 * @param config
 */
export function updateUserData(token, globalUserId, config = {}) {
  tokenService.updateToken.call(this, token);
  localUserId.update.call(this, globalUserId);
  if (config.cookie) {
    const { name, expirationTime } = config.cookie;
    const jwtCookie = this.jwtCookie;
    setCookie(name || jwtCookie.name, token, expirationTime || jwtCookie.expirationTime);
  }
}
